/* eslint-disable max-len */
export default {
    title: {
        threats: 'Erfahren Sie, wie Sie Ihre Daten schützen können.',
        offer: 'Finden Sie heraus, welche Tools Ihnen umfassende Sicherheit bieten.',
        minimize: 'Möchten Sie das Risiko von Cyberangriffen in Ihrem Unternehmen minimieren?',
        estimate: 'Möchten Sie die Sicherheit Ihrer Anwendungen erhöhen?',
        breach: 'Sind Sie Opfer eines Cyberangriffs?',
        // risk: 'Möchten Sie Ihr Unternehmen auf die DSGVO-Konformität vorbereiten?',
        audit: 'Möchten Sie, dass Ihre Anwendung / Ihr IT-System DSGVO-konform ist?',
        bottom: 'Sind Sie an einer umfassenden Lösung<br/> in Bezug auf die Sicherheit Ihrer Ressourcen und gesammelten Daten interessiert?',
        contact: 'Kontaktieren Sie uns so schnell wie möglich!'
    },
    placeholder: {
        email: 'Ihre geschäftliche E-Mail-Adresse',
        phone: 'Telefon '

    },
    button: {
        offer: 'Vereinbaren Sie eine Beratung',
        consultation: 'Vereinbaren Sie eine kostenlose Beratung',
        breach: 'Erfahren Sie, welche Schritte Sie nach einem Angriff unternehmen müssen',
        refresh: 'Neu Laden'
        // risk: 'Erhalten Sie eine Risikoanalyse'
    },
    message: {
        general_error: 'Bitte füllen Sie alle Felder korrekt aus',
        domain_error: 'Wir akzeptieren keine temporären E-Mail-Adressen. Geben Sie eine korrekte E-Mail-Adresse ein',
        recaptcha_error: 'Es ist ein Fehler aufgetreten. Bitte klicken Sie auf die Schaltfläche Neu Laden und versuchen Sie es erneut.',
        server_error: 'Temporärer Serverfehler. Senden Sie eine Nachricht an contact@lemlock.com',
        success: 'Nachricht wurde gesendet'

    },
    link: {
        breach: 'https://www.lemlock.de/verfahren-bei-cyberangriffen/'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/de/form.js